const realIds = {};
let counter = 0;
const MAX_DELAY = Math.pow(2, 31) - 1;
export function setLargeTimeout(handler, timeout, ...args) {
    return _setLargeTimeout(counter++, handler, timeout, ...args);
}
function _setLargeTimeout(index, handler, timeout, ...args) {
    if (!timeout || timeout <= MAX_DELAY) {
        realIds[index] = window.setTimeout(() => {
            delete realIds[index];
            handler.call(undefined, ...args);
        }, timeout, ...args);
        return index;
    }
    timeout -= MAX_DELAY;
    realIds[index] = window.setTimeout(() => {
        _setLargeTimeout(index, handler, timeout, ...args);
    }, MAX_DELAY);
    return index;
}
export function clearLargeTimeout(handle) {
    const realTimerId = realIds[handle];
    delete realIds[handle];
    if (!realTimerId) {
        return;
    }
    window.clearTimeout(realTimerId);
}
//# sourceMappingURL=largeTimeout.js.map